import { AppMessageService } from './app-message.service';

export default angular
  .module('sfMobile.services.app-message', ['sfMobile.services.pubsub'])
  .service('appMessageService', AppMessageService).name;
